import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    alwaysShow: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login.vue"),
    meta: {
      title: "登录",
      requireAuth: true,
    },
  },
  {
    path: "/404",
    name: "404",
    alwaysShow: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/errorPage.vue"),
  },
  {
    path: "/ssoLogin",
    name: "sysLogin",
    alwaysShow: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/sysLogin/Login.vue"),
  },
  {
    path: "/institute",
    name: "institute",
    alwaysShow: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/sysLogin/Institute.vue"),
  },
  {
    path: "/relogin",
    name: "relogin",
    alwaysShow: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/clearPage.vue"),
  },
  {
    path: "/wwLogin",
    name: "wwLogin",
    alwaysShow: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/sysLogin/wwLogin.vue"),
  },
  {
    path: "/register",
    name: "register",
    alwaysShow: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/register.vue"),
  },
  // {
  //   path: "/test",
  //   name: "test",
  //   alwaysShow: true,
  //   component:()=>import(/* webpackChunkName: "about" */ '../components/upload.vue')

  // },
  {
    path: "/",
    name: "index",
    // redirect: '/user',
    redirect: "/ssoLogin",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/index.vue"),
    meta: {
      title: "首页",
      requireAuth: true,
    },
    children: [
      {
        path: "/user",
        name: "user",
        alwaysShow: true,
        component: (resolve) => require(["../views/user/user.vue"], resolve),
      },
      {
        path: "/expired",
        name: "expired",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/expired/expired.vue"], resolve),
      },
      {
        path: "/org",
        name: "org",
        alwaysShow: true,
        component: (resolve) => require(["../views/org/org.vue"], resolve),
      },
      {
        path: "/aiorg",
        name: "aiOrg",
        alwaysShow: true,
        component: (resolve) => require(["../views/aiOrg/aiOrg.vue"], resolve),
      },
      {
        path: "/aiuser",
        name: "aiUser",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/aiUser/aiUser.vue"], resolve),
      },
      {
        path: "/partyLogin",
        name: "partyLogin",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/partyLogin/partyLogin.vue"], resolve),
      },
      {
        path: "/appUser",
        name: "appUser",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/appUser/appUser.vue"], resolve),
      },
      {
        path: "/appRun",
        name: "appRun",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/appRun/appRun.vue"], resolve),
      },
      {
        path: "/registerList",
        name: "registerList",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/register/register.vue"], resolve),
      },
      {
        path: "/stateLogin",
        name: "stateLogin",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/statement/stateLogin.vue"], resolve),
      },
      {
        path: "/stateTotal",
        name: "stateTotal",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/statement/stateTotal.vue"], resolve),
      },
      {
        path: "/hospitalTotal",
        name: "hospitalTotal",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/statement/hospitalTotal.vue"], resolve),
      },
      {
        path: "/hospitalSumMore",
        name: "hospitalSumMore",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/statement/hospitalSumMore.vue"], resolve),
      },
      {
        path: "/siteState",
        name: "siteState",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/third/siteState.vue"], resolve),
      },
      {
        path: "/jigouTongji",
        name: "jigouTongji",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/statement/jigouTongji.vue"], resolve),
      },
      {
        path: "/foreignStateLogin",
        name: "foreignStateLogin",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/waiWenStatement/foreignStateLogin.vue"], resolve),
      },
      {
        path: "/foreignStateTotal",
        name: "foreignStateTotal",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/waiWenStatement/foreignStateTotal.vue"], resolve),
      },
      {
        path: "/foreignDate",
        name: "foreignDate",
        alwaysShow: true,
        component: (resolve) =>
          require(["../views/waiWenStatement/foreignDate.vue"], resolve),
      },
      {
        path: "/foreignHospitalSumMore",
        name: "foreignHospitalSumMore",
        alwaysShow: true,
        component: (resolve) =>
          require([
            "../views/waiWenStatement/foreignHospitalSumMore.vue",
          ], resolve),
      },
    ],
  },
];

const router = new VueRouter({
  // mode: "history",
  routes,
});
export default router;
